var map = {
	"./icon-close.svg": 92154,
	"./icon-menu.svg": 33440,
	"./icon-triangle.svg": 35062,
	"./icon-wallet.svg": 89455,
	"./logout.svg": 91273,
	"./telegram-symbol.svg": 85618
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 71621;